/**
 * A dictionary value may wrap part of its text in highlight markup for the page. `t` hands back
 * the text without the markup, on the client and on the server alike, so both read the same.
 */
const TAG_PATTERNS = ['<span class="highlight">(.*?)<\\/span>', '<em>(.*?)<\\/em>'];

export const stripTranslationTags = (translation: string): string =>
  TAG_PATTERNS.reduce((text, pattern) => text.replace(new RegExp(pattern), (...args) => args[1]), translation);
